<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

      <div style="margin: 50px 0">
        <app-file-decrypt>
        </app-file-decrypt>
      </div>
